import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from '../service/user.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  EndPoint = "https://localhost:44316/";
  constructor(
    private authenticationService: UserService,
    private router: Router
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to api url
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.token ? currentUser.token : '';
    const isApiUrl = request.url.startsWith(this.EndPoint);
    if (isLoggedIn) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      });
      //console.log(request.headers);                     
    }


    return next.handle(request);
  }
}
export function encrypt(data) {
  let secret = (environment.SecretKey || "");
  return CryptoJS.AES.encrypt(JSON.stringify(data), secret,
    {
      keySize: 128 / 8,
      iv: secret,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
}

export function decrypt(data) {
  let secret = (environment.SecretKey || "");
  return JSON.parse(CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(data, secret,
    {
      keySize: 128 / 8,
      iv: secret,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })));
}
